<div mat-dialog-title>Bitte melden Sie sich an</div>
<div mat-dialog-content>
  <app-auth (authed)="onAuth()"></app-auth>
</div>
